export default {
  backHome: "返回首页",
  steps: {
    step0: "选择数据商品类型",
    step1: "选择数据",
    step2: "填写数据信息",
    step3: "验证数据",
    step4: "上传数据",
    stepAPi1: "填写API信息",
    stepAPi2: "配置API",
    stepAPi3: "上传API",
  },
  nextButtonText: "下一步",
  upButtonText: "上一步",
  selectType: {
    dataTitle: "以单个文件或多文件压缩包形式上传数据。",
    dataType: "文件上传",
    apiTitle: "以应用程序接口API形式上传数据，允许实时获取数据。",
    apiType: "API上传",
  },
  selectFile: {
    uploadTitle: "或拖动文件到此处",
    uploadTitleHighlight: "点击添加文件",
    uploadTips: "一次仅支持上传一个文件，多个文件可打包压缩上传",
    uploadButtonText: "点击上传",
    emptyFile: "检测到您选择的文件为空文件，请重新选择文件",
    encodingFileTips: "文件编码不是Unicode (UTF-8)，请更改编码后重新上传",
  },
  editDataInfo: {
    previewData: {
      title: "数据信息",
      titleTips: "已识别",
      titleButtonText: "修改数据文件",
      dataType: "数据名称：",
      dataSize: "文件大小：",
    },
    editData: {
      title: "数据详情",
      dataName: "数据名称",
      dataPrice: "价格",
      dataTags: "数据标签",
      dataType: "文件后缀",
      dataDesc: "数据描述",
      formButtonText: "下一步",
      dataNameRule: "请输入数据名称",
      dataPriceRule: "请输入价格",
    },
    selectAlgorithm: {
      checkboxTitle: "我授权典枢对这个数据的质量进行验证",
      algorithmName: "验证程序",
      algorithmNameTips:
        "数据验证报告是对数据的客观描述，有助于买家在购入前全面评估数据，从而促进成交。",
      algorithmButtonText: "下一步",
      algorithmNameRule: "请选择验证程序",
      noAlgorithm:
        "当前版本暂不支持该文件格式的数据质量验证，我们将在后续版本中提供验证支持，敬请期待。",
    },
    encryptData: {
      pendingTitle: "上传进度",
      uploadOtherButtonText: "发布更多数据",
      dataInfoButtonText: "查看详情",
      progressTips1: "数据正在上传中，您也可以在",
      progressTips2: "中查看数据上传进度",
      successTitle: "数据上传完成！正在审核中",
      errorTitle: "数据上传失败！",
    },
  },
  editAPIDataInfo: {
    previewData: {
      title: "API信息",
      titleTips: "已识别",
      titleButtonText: "修改数据文件",
      dataType: "数据名称：",
      dataSize: "文件大小：",
    },
    editData: {
      title: "API基本信息",
      dataName: "API名称",
      dataPrice: "价格（元/次）",
      dataTags: "API标签",
      dataDesc: "API描述",
      formButtonText: "下一步",
      dataNameRule: "请输入API名称",
      dataPriceRule: "请输入价格",
    },
    apiConfigData: {
      title: "API配置信息",
      requestUrl: "调用地址",
      requestUrlRule: "请输入调用地址",
      requestMethod: "请求方式",
      requestMethodRule: "请输入请求方式",
      headersParams: "请求参数（Headers）",
      queryParams: "请求参数（Query）",
      bodyParams: "请求参数（Body）",
      requestUrlGuidelines:
        "相关参数信息（如果您提供的调用地址有访问限制，请将相关授权参数信息添加到Headers中，以便典枢平台封装您的API接口，从而确保买方可以成功调用。平台承诺不会将这些信息泄露给第三方。）：",
      requestUrlGuidelines2: "相关参数信息",
      parameterName: "参数名",
      isRequired: "必填",
      exampleValue: "示例",
      parameterDescription: "描述",
      actionOptions: "操作",
      removeParameter: "移除",
      additionalExampleInfo: "相关示例信息",
      addNewRow: "+ 新增一行",
      successfulResponseExample: "成功返回示例",
      successfulResponseExampleTip: "请输入代码格式的成功返回示例",
      successfulParameterDescription: "成功参数说明",
      failedResponseExample: "失败返回示例",
      failedResponseExampleTip: "请输入代码格式的失败返回示例",
      failedParameterDescription: "失败参数说明",
      errorCodeExplanation: "错误码",
      errorDescription: "错误信息",
      debuggingFeature: "调试",
      debuggingResult: "调试结果",
      debuggingResultDescription:
        "数据商品详情中将显示该调试结果，请确保调试成功，以帮助买家做出购买决策。",
      debuggingResultDescriptionNoData: "接口返回结果为空",
    },
    selectAlgorithm: {
      checkboxTitle: "我授权典枢对这个数据的质量进行验证",
      algorithmName: "验证程序",
      algorithmNameTips:
        "数据验证报告是对数据的客观描述，有助于买家在购入前全面评估数据，从而促进成交。",
      algorithmButtonText: "下一步",
      algorithmNameRule: "请选择验证程序",
      noAlgorithm:
        "当前版本暂不支持该文件格式的数据质量验证，我们将在后续版本中提供验证支持，敬请期待。",
    },
    encryptData: {
      pendingTitle: "上传进度",
      uploadOtherButtonText: "发布更多数据",
      dataInfoButtonText: "查看详情",
      progressTips1: "数据正在上传中，您也可以在",
      progressTips2: "中查看数据上传进度",
      successTitle: "数据上传完成！正在审核中",
      errorTitle: "数据上传失败！",
    },
  },
  uploadLog: {
    alertText:
      '<strong style="color: #000000;">点击提交</strong>意味着授权典枢平台查看您的操作日志',
  },
  connecting_server: "正在连接服务器...",
  view_advanced_options: "高级设置",
  transaction_audit: "开启交易审核功能",
  audit_tooltip:
    "开启后，数据买家付款完成将进入交易审核阶段，您需要对买家身份及资质进行审核，审核通过后买家方可下载数据。此功能适用于敏感数据产品或特定用户限定交易。<br/><p style='color:#9DA1FF'>您需在七天内完成审核，逾期未处理将默认您拒绝此次交易，系统将自动退款给买家。</p>",
  use_custom_server: "自定义数据上传服务器",
  custom_server_tooltip:
    "您可自定义数据上传服务器，配置成功后，数据买家将直接连通您指定的服务器下载数据。",
  server_setup_instruction:
    "在使用此功能前，请确保您的服务器已正确部署典枢连接器服务端。具体部署步骤请参考",
  dian_connector: "典枢连接器服务端部署",
  setup_guide_prefix: "具体安装步骤请参考",
  setup_guide: "典枢客户端配置指南",
  contact_support: "如需帮助，请联系典枢客服获取技术支持。",
  server_address: "服务器地址",
  enter_server_address: "请输入服务器地址",
  test_connection: "连接测试",
  server_format_instruction:
    "请确保按照正确的格式输入服务器地址。（示例）HTTP服务：http://192.168.110.123或http://your.domain.name",
  object_storage_example: "1. 对象存储: https://<bucket>.<service>/<object>",
  http_example: "2. 自定HTTP: https://files.example.com/path/filename.ext",
  protocol_examples: "3. 共享协议:",
  smb_example: "SMB:smb://host/share/",
  nfs_example: "NFS:nfs://host/",
  stored_server_address: "该数据存储的服务器地址为：",
  connection_test_failed: "连接测试失败",
  contact_support_with_info: "请点击右下角的客服图标联系客服，并提供以上信息。",
};
